import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-spinning-logo',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div 
      class="spinning-logo-container"
      [style.min-width.px]="size * 3"
      [style.min-height.px]="size * 3">
      <div class="spinning-logo-wrapper" [style.padding-bottom.px]="size * 3">
        <!-- Inner circle - slow spin -->
        <div 
          class="spinning-circle inner"
          [style.top.px]="size"
          [style.left.px]="size"
          [style.width.px]="size"
          [style.height.px]="size">
          <img 
            src="assets/inner.svg"
            alt="Loading"
            [style.width.px]="size"
            [style.height.px]="size" />
        </div>
        <!-- Middle circle - medium spin -->
        <div 
          class="spinning-circle middle"
          [style.top.px]="size / 2"
          [style.left.px]="size / 2"
          [style.width.px]="size * 2"
          [style.height.px]="size * 2">
          <img 
            src="assets/middle.svg"
            alt="Loading"
            [style.width.px]="size * 2"
            [style.height.px]="size * 2" />
        </div>
        <!-- Outer circle - fast spin -->
        <div 
          class="spinning-circle outer"
          [style.top]="0"
          [style.left]="0"
          [style.width.px]="size * 3"
          [style.height.px]="size * 3">
          <img 
            src="assets/outer.svg"
            alt="Loading"
            [style.width.px]="size * 3"
            [style.height.px]="size * 3" />
        </div>
      </div>
    </div>
  `,
    styles: [`
    .spinning-logo-container {
      display: flex;
      justify-content: center;
      width: fit-content;
      height: fit-content;
    }

    .spinning-logo-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .spinning-circle {
      position: absolute;
      aspect-ratio: 1;
    }

    .spinning-circle img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .spinning-circle.inner {
      animation: spin-slow-sync 4s ease-in-out infinite;
    }

    .spinning-circle.middle {
      animation: spin-medium-sync 4s ease-in-out infinite;
    }

    .spinning-circle.outer {
      animation: spin-fast-sync 4s ease-in-out infinite;
    }

    /* INNER (slow): 3 rotations (1080°) over 3s, then 1s hold */
    @keyframes spin-slow-sync {
      0% {
        transform: rotate(0deg);
      }
      75% {
        transform: rotate(1080deg);
      }
      100% {
        transform: rotate(1080deg);
      }
    }

    /* MIDDLE (medium): 2 rotations (720°) over 3s, then 1s hold */
    @keyframes spin-medium-sync {
      0% {
        transform: rotate(0deg);
      }
      75% {
        transform: rotate(720deg);
      }
      100% {
        transform: rotate(720deg);
      }
    }

    /* OUTER (fast): 1 rotation (360°) over 3s, then 1s hold */
    @keyframes spin-fast-sync {
      0% {
        transform: rotate(0deg);
      }
      75% {
        transform: rotate(360deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `]
})
export class SpinningLogoComponent {
    @Input() size: number = 15;
}
